export const Marquee = () => {
  const text = "RECANTO DOS PINHEIROS — REFÚGIO NA NATUREZA — ATIBAIA · SP — ";
  return (
    <section className="bg-brand-forest py-6 md:py-8 overflow-hidden border-y border-brand-forest-light/40" data-testid="marquee">
      <div className="animate-marquee">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="text-brand-cream/90 text-3xl md:text-5xl font-bold tracking-tight uppercase px-4"
          >
            {text.repeat(3)}
          </span>
        ))}
      </div>
    </section>
  );
};
